module.exports = __webpack_public_path__ + "img/rws-logo.567d2798.png";